// Наваждение as the confused player sees it: every other hero's team colours swapped (model accents, HP
// plates, minimap dots), so allies read as enemies and the reverse. Your own hero keeps its colour — if it
// flipped too, you and your allies would still match and nothing would be confusing. Only the viewer's own
// hero being confused counts; a confused hero seen from outside gets a mark instead (fx.ts).
import type { Team } from '../core/layout.js';
import type { GameView, ViewHero } from './gameView.js';

export const otherTeam = (t: Team): Team => (t === 'a' ? 'b' : 'a');

/** True while the hero this view is played from (never a replay's mere anchor) stands confused. */
export function viewerConfused(view: GameView): boolean {
  const p = view.player;
  return !!p && p.player && p.alive && !!view.statusOf(p).confused;
}

/** The team whose colours `h` is drawn in. */
export function shownTeam(h: ViewHero, viewer: ViewHero | undefined, confused: boolean): Team {
  return confused && h !== viewer ? otherTeam(h.team) : h.team;
}
